import { alfrescoTypes } from '../../../constants.js';
import vacationClaim from './VacationClaim.js';
import certification from './Certification.js';
import travelLetterAuto from './TravelLetterAuto.js';
import advanceReport from './AdvanceReport.js';
import businessTrip from './BusinessTrip.js';
import transferRequest from './TransferRequest.js';
import unstructuredDocument from './UnstructuredDocument.js';
import details from './Details.js';

export const documentTypeRegistry = {
    [alfrescoTypes.vacationClaim]: vacationClaim,
    [alfrescoTypes.certification]: certification,
    [alfrescoTypes.travelLetterAuto]: travelLetterAuto,
    [alfrescoTypes.advanceReport]: advanceReport,
    [alfrescoTypes.businessTrip]: businessTrip,
    [alfrescoTypes.transferRequest]: transferRequest,
    [alfrescoTypes.unstructuredDocument]: unstructuredDocument,
    [alfrescoTypes.details]: details
};

export const getDocumentTypeConfig = (type) =>
    documentTypeRegistry[type] ?? null;